import React from "react";
import { AI } from "./features/AI/AI";
import "./App.css";

function App() {
  return (
    <div className="App">
      <AI />
    </div>
  );
}

export default App;
